import { render } from "./schoolstamp.vue?vue&type=template&id=0a6c76e8&scoped=true"
import script from "./schoolstamp.vue?vue&type=script&lang=js"
export * from "./schoolstamp.vue?vue&type=script&lang=js"

import "@/assets/css/ts-table.css?vue&type=style&index=0&id=0a6c76e8&scoped=true&lang=css&external"
import "./schoolstamp.vue?vue&type=style&index=1&id=0a6c76e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a6c76e8"]])

export default __exports__